import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-support-website-overview/src/HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { horizontalNavigationCsmSupportWebsiteEntryPoint } from '@jira/navigation-apps__horizontal-nav-csm-support-website/src/horizontalNavigationCsmSupportWebsiteEntryPoint.entrypoint.tsx';
import { csmExperienceSupportWebsiteOverviewRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceSupportWebsiteOverviewRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmBaseUrlResource } from '@jira/router-resources__service-desk-customer-service-csm-base-url/src/csmBaseUrlResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceSupportWebsiteOverviewPageEntryPoint = createPageEntryPoint({
	main,
	horizontalNavigation: horizontalNavigationCsmSupportWebsiteEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceSupportWebsiteOverviewRouteEntry: Route = createEntry(
	csmExperienceSupportWebsiteOverviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-support-website.overview',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceSupportWebsiteOverviewPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			csmHubSetupSupportWebsiteResource,
			csmBaseUrlResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
